import React from 'react';
export default function LabelValueCell({ label, value }) {
  return (
    <>
      <div className="font-weight-500">{label}</div>
      <div className="font-weight-400 fs-sm text-muted">{value}</div>
    </>
  );
}
